<script setup lang="ts">
import { VideoFragment } from '@/graphql/generated-types';
import { IVideo } from '@/interfaces';
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import MediaPreview from '@/overlays/MediaPreviewOverlay.vue';
import VideosGrid from '@/views/shared/VideosGrid.vue';
import { ref } from 'vue';

const emit = defineEmits(['close']);

interface Props {
  videos: (IVideo | VideoFragment)[];
  isPersonalMedia?: boolean;
}

withDefaults(defineProps<Props>(), {});

const showMediaPreview = ref<boolean>(false);
const selectedMediaIndex = ref<number>(-1);

const videoSelected = (index: number) => {
  selectedMediaIndex.value = index;
  showMediaPreview.value = true;
};
</script>

<template>
  <BaseOverlay
    @close="emit('close')"
    :title="isPersonalMedia ? $t('media.myVideos') : $t('global.videos')"
  >
    <template #content>
      <VideosGrid :videos="videos" @video-selected="videoSelected" />
    </template>
  </BaseOverlay>

  <MediaPreview
    v-if="showMediaPreview"
    media-type="videos"
    :selected-item-index="selectedMediaIndex"
    :items="videos"
    :allow-archive-remove="isPersonalMedia"
    @close-preview="showMediaPreview = false"
  />
</template>
